import { Base64 } from 'js-base64'

const getIdDocMaster = (doc, fascicolo) => {
  if (doc) {
    if (doc.id_doc_master) return doc.id_doc_master
    if (doc.idDocMaster) return doc.idDocMaster
    if (doc._source && doc._source.provvedimento && doc._source.provvedimento.idDocMaster) return doc._source.provvedimento.idDocMaster
    if (doc.provvedimento && doc.provvedimento.id_doc_master) return doc.provvedimento.id_doc_master
  }
  if (fascicolo) {
    if (fascicolo.provvedimento && fascicolo.provvedimento.id_doc_master) return fascicolo.provvedimento.id_doc_master
    if (fascicolo._source && fascicolo._source.provvedimento && fascicolo._source.provvedimento.idDocMaster) return fascicolo._source.provvedimento.idDocMaster
  }
  return null
}

const getIdUnitaDoc = (doc, fascicolo) => {
  if (doc) {
    if (doc.id_unita_doc) return doc.id_unita_doc
    if (doc.idUnitaDoc) return doc.idUnitaDoc
    if (doc.campo_calcolato && doc.campo_calcolato.id_unita_doc) return doc.campo_calcolato.id_unita_doc
    if (doc._source && doc._source.documento) {
      if (doc._source.documento.id_unita_doc) return doc._source.documento.id_unita_doc
      if (doc._source.documento.idUnitaDoc) return doc._source.documento.idUnitaDoc
    }
    if (doc._source && doc._source.id_unita_doc) return doc._source.id_unita_doc
  }
  if (fascicolo && fascicolo.documenti && fascicolo.documenti.length > 0) return fascicolo.documenti[0].id_unita_doc
  return null
}

const getViewerPropertiesParam = (settings) => {
  try {
    if (!settings || settings.freeToken) return ''
    var props = settings.properties.abbonato
    if (!props) return ''
    return '&properties=' + Base64.encode(JSON.stringify(props))
  } catch (e) {
    return ''
  }
}

export default {
  isEnabled(settings) {
    return !!(settings && settings.new_pdfviewer)
  },
  buildUrl(settings, doc, fascicolo) {
    if (!this.isEnabled(settings)) return null
    const idDocMaster = getIdDocMaster(doc, fascicolo)
    const idUnitaDoc = getIdUnitaDoc(doc, fascicolo)
    if (!idDocMaster || !idUnitaDoc) return null
    const token = localStorage.token_biblio_riv_jwt || ''
    var url = settings.new_pdfviewer
      .replace(/\{\{id_doc_master\}\}/g, idDocMaster)
      .replace(/\{\{id_unita_doc\}\}/g, idUnitaDoc)
      .replace(/\{\{token_jwt\}\}/g, token)
    return url + getViewerPropertiesParam(settings)
  }
}
